<template>
    <v-col
      cols="12"
      md="11"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "Col11"
}
</script>

<style scoped>

</style>